import { generateString, getCurrentUi } from 'designer/component/action/Data'
import { renderRefreshTable } from 'designer/component/action/Table'
import objectPath from 'object-path'
import { setRequestFormData } from './Request'
import { onCheckCondition } from 'designer/component/action/condition/Action'
import { getFormGroup } from 'designer/component/action/FormGroup'
import { genRefId } from 'designer/component/element/table/action/index'
import {
  addBulkToTable,
  addMultiSelectToTable,
  addSingleToTable,
  addTableToTable,
} from './buttonAction/AddToTable'

export const refreshTable = async ({ action, data, designContext }) => {
  let { allParams, formData } = data
  const {
    jsonForm,
    setFormData,
    setComponentPropsData,
    searchData,
    setTableRefresh,
    getCurrentUi,
    tabParamActive,
    isUiChanged,
  } = designContext

  let schema = jsonForm.schema
  let tableList = action?.table || []
  const componentPropsData = objectPath.get(jsonForm, 'componentPropsData')
  const designerData = objectPath.get(componentPropsData, 'data')

  let onAction = {
    setLoading: () => {},
    setPage: () => {},
    setRowsPerPage: () => {},
    setTotalCount: () => {},
    setTableColumn: () => {},
    setTableData: () => {},
    setComponentPropsData: setComponentPropsData,
    setFormData: setFormData,
  }
  let propTable = {
    formData: { ...formData, ...searchData },
    allParams: allParams,
    designerData: designerData,
    tabParamActive: tabParamActive,
    componentPropsData: componentPropsData,
    search: jsonForm.search,
    dynamicData: {},
    onAction: onAction,
    designContext,
  }
  tableList.forEach(async (tableKey) => {
    let uischema
    let isWidget = objectPath.has(schema, `mapWidget.ui.${tableKey}`)
    if (isWidget) {
      uischema = objectPath.get(schema, `mapWidget.ui.${tableKey}`)
    } else {
      uischema = getCurrentUi(tableKey, jsonForm.schema, jsonForm.uischema)
    }
    const tablePagination =
      objectPath.get(isUiChanged, ['pageTable', uischema.key]) || {}
    const currentPage = Number(tablePagination.page)
    let totalCount
    const refreshPropTable = {
      ...propTable,
      uischema,
      pagination: {
        page: Number.isFinite(currentPage) ? currentPage + 1 : 1,
        rowsPerPage: tablePagination.rowsPerPage || uischema.rowsPerPage,
      },
      onAction: {
        ...onAction,
        setTotalCount: (value) => {
          totalCount = value
        },
      },
    }
    renderRefreshTable(refreshPropTable).then((tableData) => {
      setTableRefresh([
        { key: tableKey, isButton: true, data: tableData, totalCount },
      ])
    })
  })
  return {
    status: 200,
    message: '',
    data: {},
  }
}

export const unselectRow = ({ action, data, designContext }) => {
  const {
    jsonForm,
    isUiChanged,
    setIsUiChanged,
    setComponentPropsData,
    setFieldFormData,
  } = designContext
  let { table } = action
  if (table) {
    let formData = jsonForm.formData
    let componentPropsData = objectPath.get(jsonForm, 'componentPropsData')
    table.forEach((tableKey) => {
      objectPath.set(componentPropsData, 'data', {})
      objectPath.set(componentPropsData, 'isClosed', false)
      objectPath.set(componentPropsData, 'isSelectedRow', false)
      objectPath.set(componentPropsData, 'rowData', {})
      setComponentPropsData(componentPropsData)
      setFieldFormData(`@rowSelected.${tableKey}`, {})
      onCheckCondition(designContext, formData, tableKey, {
        isSelectRow: false,
      })
      objectPath.set(isUiChanged, tableKey, {
        isRender: true,
        isUnselectFromButton: true,
      })
    })
    setIsUiChanged(isUiChanged)
  }
}

export const addToTable = ({ action, data, designContext }) => {
  const { setDatasourceValue, getCurrentUi } = designContext
  let { formData, datasourceValue } = data
  let { datasourceKey, tableKey, requestDataType } = action
  if (!tableKey) {
    return {
      status: 500,
      message: 'Not found table',
      data: null,
    }
  }
  let tableUi = getCurrentUi(tableKey)
  let tableData = objectPath.get(formData, tableUi.key)
  tableData = Array.isArray(tableData) ? tableData : []
  if (requestDataType === 'table') {
    tableData = addTableToTable({ action, data, designContext })
  } else if (requestDataType === 'single') {
    tableData = addSingleToTable({ action, data, designContext })
  } else if (requestDataType === 'bulk') {
    tableData = addBulkToTable({ action, data, designContext })
  } else if (requestDataType === 'multiSelect') {
    tableData = addMultiSelectToTable({ action, data, designContext })
  }
  if (datasourceKey) {
    let datasourceTable = objectPath.get(datasourceValue, datasourceKey)
    datasourceTable = Array.isArray(datasourceTable) ? datasourceTable : []
    let newDataSourceTable = datasourceTable
    tableData.forEach((newItem) => {
      let foundAdded = datasourceTable.find((oldItem) => oldItem === newItem)
      if (foundAdded) return
      newDataSourceTable.push(newItem)
    })
    objectPath.set(datasourceValue, datasourceKey, newDataSourceTable)
    setDatasourceValue(datasourceValue)
  }
  objectPath.set(formData, tableKey, tableData)
  objectPath.set(formData, tableUi.name, tableData)
  return {
    status: 200,
    message: 'Success add data to table',
    data: formData,
  }
}

export const updateToTable = ({ action, data, designContext }) => {
  const { jsonForm, setDatasourceValue, getCurrentUi } = designContext
  const allFormGroup = getFormGroup(designContext)
  let { formData, datasourceValue } = data
  const allBulkGroup = jsonForm?.bulkGroup || []
  let {
    formDataKey,
    bulkDataKey,
    tableKey,
    datasourceKey,
    requestDataType,
    isUpdateAllRow,
    mapColumn = [],
  } = action

  if (!tableKey) {
    return {
      status: 500,
      message: 'Not found table',
      data: null,
    }
  }
  let tableUi = getCurrentUi(tableKey)
  let { tableColumn = [] } = tableUi
  let columnRefId = objectPath.get(tableUi, 'loadData.columnRefId')
  let rowDataSelect = objectPath.get(formData, `@rowSelected.${tableUi.key}`)
  let tableData = objectPath.get(formData, tableUi.key) || []
  let tableIndex = tableData.findIndex((rowData) => {
    let isCheckFromGenId =
      objectPath.get(rowData, genRefId) ===
      objectPath.get(rowDataSelect, genRefId)
    if (
      objectPath.has(rowDataSelect, genRefId) &&
      objectPath.has(rowData, genRefId)
    ) {
      return isCheckFromGenId
    }
    let isCheckFromColumnRefId =
      objectPath.get(rowData, columnRefId) ===
      objectPath.get(rowDataSelect, columnRefId)
    return isCheckFromColumnRefId
  })

  if (isUpdateAllRow) {
    if (requestDataType === 'single') {
      let form = allFormGroup.find((form) => form.key === formDataKey)
      if (!formDataKey || !form) {
        return {
          status: 500,
          message: 'Not found form data',
          data: null,
        }
      }
      let requestBody = {}
      requestBody = setRequestFormData({
        form,
        requestBody,
        designContext,
        data,
      })
      tableData.map((rowData) => {
        mapColumn.forEach(({ bulkKey, value }) => {
          let requestValue = objectPath.get(requestBody, bulkKey)
          objectPath.set(rowData, value, requestValue)
        })
      })
    }
  } else if (tableIndex > -1) {
    if (requestDataType === 'single') {
      let form = allFormGroup.find((form) => form.key === formDataKey)
      if (!formDataKey || !form) {
        return {
          status: 500,
          message: 'Not found form data',
          data: null,
        }
      }
      let requestBody = {}
      requestBody = setRequestFormData({
        form,
        requestBody,
        designContext,
        data,
      })
      tableData[tableIndex] = { ...rowDataSelect, ...requestBody }
    } else if (requestDataType === 'bulk') {
      let bulkGroup = allBulkGroup.find(({ key }) => key === bulkDataKey)
      let { bulkTable = [] } = bulkGroup
      let bulkKey = bulkGroup?.mainBulk?.key
      let bulkUi = getCurrentUi(bulkKey)
      let bulkName = bulkUi.name
      let bulkData = objectPath.get(formData, bulkKey)

      if (!bulkData) {
        return {
          status: 500,
          message: 'Not found added data',
          data: null,
        }
      }
      if (!Array.isArray(bulkData)) {
        bulkData = [bulkData]
      }

      let mapTag = jsonForm.schema.mapTag
      let mapKey = jsonForm.schema.mapKey
      let subList = Object.keys(mapTag).filter((key) => {
        let tag = mapTag[key]
        let fullKey = mapKey[key]
        return (
          tag === 'list' &&
          key !== bulkKey &&
          fullKey.split('.').includes(bulkKey)
        )
      })
      console.log('updateToTable bulkData', {
        bulkGroup,
        bulkUi,
        bulkKey,
        bulkName,
        bulkData,
        subList,
      })

      bulkData.forEach((rowValue) => {
        let itemRequest = {}
        objectPath.set(itemRequest, bulkName, rowValue)
        bulkTable.forEach((rowItem) => {
          let ui = getCurrentUi(rowItem.key)
          let parentElements = ui.elements
          if (rowItem.isParent) {
            let rowValue = objectPath.get(formData, ui.name)
            objectPath.set(itemRequest, ui.name, rowValue)
          } else {
            if (rowItem.isArray) {
              let { bulkChild = [] } = rowItem
              let foundParent = parentElements.find(({ name }) => {
                let bulkId = objectPath.get(formData, `@${name}.@${bulkName}`)
                return bulkId === rowValue
              })
              if (foundParent) {
                bulkChild.forEach((childItem) => {
                  let childUi = getCurrentUi(childItem.value)
                  let parentData = objectPath.get(
                    formData,
                    `@${foundParent.name}`,
                  )
                  let rowValue = objectPath.get(parentData, childUi.name)
                  objectPath.set(itemRequest, childUi.name, rowValue)
                  if (childUi.tagname === 'checkboxGroup') {
                    let checkList = objectPath.get(
                      parentData,
                      `@checkList.${childUi.key}`,
                    )
                    if (checkList) {
                      let itemList = []
                      Object.keys(checkList).forEach((key) => {
                        let value = checkList[key]
                        if (value) {
                          itemList.push(value)
                        }
                      })
                      objectPath.set(itemRequest, `@${childUi.name}`, itemList)
                    }
                  }
                })
              }
            }
          }
        })
        if (action?.isFilterCheckedValue) {
          let isChecked = objectPath.get(rowValue, '@isChecked')
          if (!isChecked) return
          subList.forEach((key) => {
            let ui = getCurrentUi(key)
            let { name, loadItem } = ui
            if (!objectPath.get(rowValue, name)) return
            const methodKey = loadItem.method
              ? loadItem.method.toLocaleLowerCase()
              : ''
            const dataMethod = methodKey
              ? objectPath.get(loadItem, `${methodKey}`)
              : {}
            if (dataMethod?.isFilterCheckedValue) {
              let subData = objectPath.get(rowValue, name)
              if (subData && Array.isArray(subData)) {
                let filterChecked = subData.filter((value) =>
                  objectPath.get(value, '@isChecked'),
                )
                objectPath.set(rowValue, name, filterChecked)
              }
              itemRequest = { ...itemRequest, ...rowValue }

              console.log('subList', key, name, {
                uiName: ui.name,
                itemRequest,
                rowValue,
                subData,
              })
            }
          })
        }

        tableData[tableIndex] = { ...rowDataSelect, ...itemRequest }
      })
      let itemRequest = tableData[tableIndex]
      tableColumn.forEach(({ field, mapOther, defaultValue, detailColumn }) => {
        if (objectPath.has(itemRequest, `@${field}`)) {
          if (mapOther) {
            mapOther.forEach((other) => {
              let otherValue = objectPath.get(
                itemRequest,
                `@${field}.${other.value}`,
              )
              objectPath.set(itemRequest, other.field, otherValue)
            })
          }
        }
        if (!objectPath.has(itemRequest, field)) {
          objectPath.set(itemRequest, field, defaultValue)
        }
        if (detailColumn) {
          let subRowData = objectPath.get(itemRequest, field) || []
          detailColumn.forEach((subItem) => {
            let subField = subItem.field
            let defaultValue = subItem.defaultValue
            subRowData.map((subData) => {
              if (objectPath.get(subData, subField) === undefined) {
                objectPath.set(subData, subField, defaultValue)
              }
              return subData
            })
          })
          objectPath.set(itemRequest, field, subRowData)
        }
      })
      tableData[tableIndex] = itemRequest
    }
    if (datasourceKey) {
      let datasourceTable = objectPath.get(datasourceValue, datasourceKey)
      if (datasourceTable) {
        let datasourceIndex = datasourceTable.findIndex((rowData) => {
          let isCheckFromGenId =
            objectPath.get(rowData, genRefId) ===
            objectPath.get(rowDataSelect, genRefId)
          if (
            objectPath.has(rowDataSelect, genRefId) &&
            objectPath.has(rowData, genRefId)
          ) {
            return isCheckFromGenId
          }
          let isCheckFromColumnRefId =
            objectPath.get(rowData, columnRefId) ===
            objectPath.get(rowDataSelect, columnRefId)
          return isCheckFromColumnRefId
        })
        if (datasourceIndex > -1) {
          datasourceTable[datasourceIndex] = tableData[tableIndex]
        }
        objectPath.set(datasourceValue, datasourceKey, datasourceTable)
        setDatasourceValue(datasourceValue)
      }
    }
  }
  objectPath.set(formData, tableKey, tableData)
  objectPath.set(formData, tableUi.name, tableData)
  return {
    status: 200,
    message: 'Success update data to table',
    data: formData,
  }
}
